var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes,attrs:{"role":"menuitem"}},[_c('div',{staticClass:"top-level-link-container"},[_c('router-link',{attrs:{"to":_vm.path},domProps:{"textContent":_vm._s(_vm.text)}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }